import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const GOLD = '#B8892A';
const INK = '#1A1612';
const INK3 = '#7A7268';
const INK4 = '#B0A898';
const BD = '#D8D2C8';
const BG = '#FAF8F5';

export default function RecommendSection({ onLotClick, jpyCnyRate = 0.043 }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    api.get('/smart-search/recommend').then(({ data }) => {
      setSections(data.sections || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [user]);

  if (!user || (!loading && !sections.length)) return null;

  const fmtPrice = (jpy) => {
    if (!jpy) return '';
    const cny = Math.round(jpy * jpyCnyRate);
    return `¥${cny.toLocaleString()}`;
  };

  return (
    <div style={{ padding: '0 0 8px' }}>
      {loading && (
        <div style={{ padding: '12px 10px', fontSize: 11, color: INK4, textAlign: 'center' }}>
          {t('recommend.loading')}
        </div>
      )}
      {sections.map((section, si) => (
        <div key={si} style={{ marginBottom: 8 }}>
          {/* Section header */}
          <div style={{
            padding: '8px 12px 4px', display: 'flex', alignItems: 'center', gap: 6,
          }}>
            <span style={{
              padding: '1px 6px', borderRadius: 8, fontSize: 9, fontWeight: 600,
              background: 'rgba(184,137,42,.12)', color: GOLD,
            }}>AI</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: INK }}>{section.title}</span>
            {section.reason && (
              <span style={{ fontSize: 10, color: INK4 }}>— {section.reason}</span>
            )}
          </div>

          {/* Horizontal scroll cards */}
          <div style={{
            display: 'flex', gap: 8, overflowX: 'auto', padding: '4px 12px 8px',
            WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none',
          }}>
            {(section.data || []).map(lot => {
              const images = (() => {
                try {
                  const parsed = typeof lot.image_urls === 'string' ? JSON.parse(lot.image_urls) : lot.image_urls;
                  return Array.isArray(parsed) ? parsed : [];
                } catch { return []; }
              })();
              const thumb = images[0] || '';

              return (
                <div key={lot.id}
                  onClick={() => onLotClick?.(lot)}
                  style={{
                    width: 140, flexShrink: 0, borderRadius: 8, overflow: 'hidden',
                    border: `1px solid ${BD}`, background: '#fff', cursor: 'pointer',
                    transition: 'box-shadow .15s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,.1)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                >
                  <div style={{
                    width: '100%', height: 120, background: BG,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    overflow: 'hidden',
                  }}>
                    {thumb ? (
                      <img src={thumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <span style={{ fontSize: 24, opacity: 0.3 }}>📷</span>
                    )}
                  </div>
                  <div style={{ padding: '6px 8px' }}>
                    <div style={{
                      fontSize: 11, color: INK, fontWeight: 500,
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                      {lot.title_zh || lot.title_ja || lot.brand || 'N/A'}
                    </div>
                    <div style={{ fontSize: 10, color: INK3, marginTop: 2 }}>
                      {lot.brand || ''}
                    </div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: GOLD, marginTop: 2 }}>
                      {fmtPrice(lot.current_price_jpy || lot.start_price_jpy)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
